import script from "./ImageReviewImage.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageReviewImage.vue?vue&type=script&setup=true&lang=js"

import "./ImageReviewImage.vue?vue&type=style&index=0&id=4058e4c0&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4058e4c0"]])

export default __exports__